export function calculateYearRange(min: Date, max: Date) {
  const years: number[] = []
  for (let i = min.getFullYear(); i <= max.getFullYear(); i++) {
    years.push(i)
  }

  return years
}

export function calculateMonthRange(value: Date, min: Date, max: Date) {
  let start = 1
  let end = 12
  if (value.getFullYear() === min.getFullYear()) {
    start = min.getMonth() + 1
  }
  if (value.getFullYear() === max.getFullYear()) {
    end = max.getMonth() + 1
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i)
}

export function calculateDayRange(value: Date, min: Date, max: Date) {
  let start = 1
  let end = new Date(value.getFullYear(), value.getMonth() + 1, 0).getDate()
  if (value.getFullYear() === min.getFullYear() && value.getMonth() + 1 === min.getMonth() + 1) {
    start = min.getDate()
  }
  if (value.getFullYear() === max.getFullYear() && value.getMonth() + 1 === max.getMonth() + 1) {
    end = max.getDate()
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i)
}

export function formatDateToYYYMMDD(date: Date) {
  return date.toISOString().split('T')[0]
}
